import React from 'react';
import { Info } from '@mui/icons-material';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

import type { ModalComponentProps } from '../../../components/modals/constants';

/**
 * JotCoach Feedback Modal
 *
 * Note: The feedback submission functionality has been removed as part of the
 * JotCoach SMS consolidation into JotAudit. This modal now displays a message
 * indicating that feedback collection is no longer available through this interface.
 */
const JotCoachFeedbackModal: React.FC<ModalComponentProps> = ({ closeModal }) => {
  return (
    <>
      <DialogTitle>JotCoach Feedback</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            py: 3,
            textAlign: 'center',
          }}
        >
          <Info sx={{ fontSize: 48, color: 'info.main', mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            Feedback Collection Unavailable
          </Typography>
          <Typography variant="body2" color="text.secondary">
            The feedback submission feature has been consolidated into JotAudit.
            Thank you for your interest in providing feedback!
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} variant="contained">
          Close
        </Button>
      </DialogActions>
    </>
  );
};

export default JotCoachFeedbackModal;
